import {PanelElement} from "../elements/PanelElement";
import {userDataModule} from "../../modules/UserDataModule";

export class AuthenticationPanel extends PanelElement {
    isFlowSuccess() {
        return userDataModule.isAuthenticated();
    }
}
